import Api from '@/api/api.js'

export default {
    saveConsultationProtocoleSoins(data) {
        const promise = Api().post('/protocoles/store', data)
        return promise.then(response => response.data)
    },

    getConsultationProtocoleSoins(data) {
        const promise = Api().post('/protocoles/show', data)
        return promise.then(response => response.data)
    },

    saveConsultationCatConsigne(data) {
        const promise = Api().post('/protocoles/save/cat-consigne', data)
        return promise.then(response => response.data)
    },

    deleteConsultationCatConsigne(data) {
        const promise = Api().post('/protocoles/delete/cat-consigne', data)
        return promise.then(response => response.data)
    },

    deleteProtocoleSoins(data) {
        const promise = Api().post('/protocoles/delete', data)
        return promise.then(response => response.data)
    },

    getTraitementEnCours(data) {
        const promise = Api().post('/protocoles/show/traitement-en-cours', data)
        return promise.then(response => response.data)
    },

    saveProcessStatus(data) {
        const promise = Api().post('/protocoles/set-process/traitement-en-cours', data)
        return promise.then(response => response.data)
    },

    getProtocoleData(data) {
        const promise = Api().post('/protocoles/show/protocole-data', data)
        return promise.then(response => response.data)
    },

    saveProtocoleData(data) {
        const promise = Api().post('/protocoles/store/protocole-data', data)
        return promise.then(response => response.data)
    },

    deleteProtocoleData(data) {
        const promise = Api().post('/protocoles/delete/protocole-data', data)
        return promise.then(response => response.data)
    },
}